module.exports = __webpack_public_path__ + "static/media/surfing_768.e2f4aba1.webp";